(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carzilla-stock-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('carzilla-stock-note')) {
    customElements.define('carzilla-stock-note', class extends HTMLElement {
      connectedCallback() {
        this.productSection = this.closest('.product-section');
        if (!this.productSection) return;
        this.onVariantChange = (event) => {
          const variant = event.detail && event.detail.variant;
          this.hidden = !(variant && variant.available && variant.requires_shipping);
        };
        this.productSection.addEventListener('variantChange', this.onVariantChange);
      }
      disconnectedCallback() {
        if (this.productSection && this.onVariantChange) {
          this.productSection.removeEventListener('variantChange', this.onVariantChange);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
